// extracted by mini-css-extract-plugin
export default {"item":"ItemLista_item__68EtT","disabled":"ItemLista_disabled__PROVW","selected":"ItemLista_selected__kv851"};